import React, { useState } from 'react'
import InputText from '../../../shared/input/new/InputText'
import InputSelectMultiple from '../../../shared/input/new/InputSelectMultiple'
import Btn from '../../../shared/button/Btn'
import { addNewPageOrMenu } from '../../../../features/admin5/admin5Slice'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'

const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
`

const roleDatas = [
    {
        id: 1,
        value: "Admin",
        text: "Admin"
    },
    {
        id: 2,
        value: "EgeYurtAdmin",
        text: "Ege Yurt Admin"
    },
    {
        id: 3,
        value: "DigitalLogisticsAdmin",
        text: "Dijital Lojistikçi"
    },
    {
        id: 4,
        value: "CooperativeAdmin",
        text: "Kooperatif"
    },
    {
        id: 5,
        value: "ShipperAdmin",
        text: "Yük Veren"
    },
    {
        id: 6,
        value: "DigitalLogisticsShipperAdmin",
        text: "Dijitla Lojistikçinin Yük Vereni"
    }
]

const SayfaEkle = () => {
    
    const dispatch = useDispatch()
    const { selectedMenu } = useSelector((state) => state.admin5)

    const [selectedRole, setSelectedRole] = useState([])
    const [data, setData] = useState({
        name: "",
        description: "",
        slug: ""
    })

    const handleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = () => {
        if(data.name && data.description && data.slug){
            const addData = {
                name: data.name,
                description: data.description,
                type: "permission",
                slug: data.slug,
                subLinkId: selectedMenu.id,
                roles: selectedRole.map(item => item.value)
            }
            dispatch(addNewPageOrMenu(addData))
            setData({
                name: "",
                description: "",
                slug: "" 
            })
            setSelectedRole([])
        }
    }

  return (
    <Container className="input-list">
        <InputText data={data?.name} setData={(e) => handleChange(e)} name={"name"} labelText='Rol Adı' inputWidth={"100%"} />
        <InputText data={data?.description} setData={(e) => handleChange(e)} name={"description"} labelText='Sayfa Adı' inputWidth={"100%"} />
        <InputText data={data?.slug} setData={(e) => handleChange(e)} name={"slug"} labelText='Sayfa Uzantısı' inputWidth={"100%"} />
        <InputSelectMultiple data={selectedRole} setData={setSelectedRole} labelText='Rol Seçimi' name={"role"} inputWidth={"100%"} options={roleDatas} />
        <Btn width={"240px"} bgColor="transparent" color="#E85446" handleClick={handleSubmit} >Ekle</Btn>
    </Container>
  )
}

export default SayfaEkle